import * as React from 'react';
import { useSelector } from 'react-redux';

import { FloatingLabel } from 'shared/components/FloatingLabel';
import { selectDailyrentActionType } from 'shared/selectors/dailyrentActionType';
import { EActionType } from 'shared/types/dailyrentActionButtonsType';
import { useIsDailyrentOnlineBookingEnabled } from 'shared/utils/featureToggles/useIsDailyrentOnlineBookingEnabled';

import boltIcon from './assets/bolt.svg';

export function InstantBookingLabelContainer() {
  const isOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();
  const actionType = useSelector(selectDailyrentActionType);
  const isOnlineBooking =
    isOnlineBookingEnabled &&
    actionType &&
    [
      EActionType.OtaBooking,
      EActionType.OtaCheckDates,
      EActionType.PartnerBooking,
      EActionType.PartnerCheckDates,
    ].includes(actionType);

  if (!isOnlineBooking) {
    return null;
  }

  return (
    <FloatingLabel
      data-testid="InstantBookingLabel"
      labelText="Мгновенная бронь"
      tooltipText="Это жильё можно забронировать без переговоров с владельцем и долгого ожидания подтверждения брони"
      color="primary_100"
      backgroundColor="primary_10"
      icon={<img src={boltIcon} alt="" />}
    />
  );
}
